import cn from "classnames";
import {
    CheckRegistryPointsBtn,
    FixRouteBidBtn,
    FixRouteBidForm,
    Map as LeafletMap,
    MapControl,
    MarkerCluster,
    RequireForwardingOrderBtn,
    RouteMarker,
} from "components/map/shared";
import Loader from "components/shared/loader";
import { dateTimeToView } from "helpers/date";
import { bidPointTypesEnum } from "helpers/enums";
import React, { Component } from "react";
import { Circle, Polygon, ZoomControl } from "react-leaflet";
import Filter from "./filter";
import "moment-duration-format";
import UpdateRoute, { applyBidRoute } from "components/shared/updateRoute";
import { isStartBidPoint, START_POINT_LETTER } from "helpers/bidpoint";
import { load, store } from "helpers/filtersStorage";
import { isTechSupport } from "helpers/hiddenData";
import {
    getClientRouteOptions,
    routeOptionsWithoutSeasonalRestrictions,
    seasonalRestrictionsConfirmParams,
} from "helpers/map";
import { paths } from "helpers/paths";
import { isRegionDryingPeriodsEnabledForClients } from "helpers/regionDryingPeriods";
import { noRolesOtherThan } from "helpers/roles";
import { canManageOrganization, pointLetter } from "helpers/system";
import compact from "lodash/compact";
import { geocoder, getRoute } from "sources/map";

const ROOT_PAGE_LINKS = ["/", "/monitoring"];

const points = [
    { value: 1, cname: "platon", center: [55.7473, 52.4497] },
    { value: 2, cname: "camera", center: [55.7473, 52.4518] },
    { value: 3, cname: "azs", center: [55.7473, 52.4543] },
    { value: 4, cname: "toilet", center: [55.7473, 52.4568] },
    { value: 5, cname: "wash", center: [55.7473, 52.4593] },
    { value: 6, cname: "wrecker", center: [55.7458, 52.4497] },
    { value: 7, cname: "dps", center: [55.7458, 52.4518] },
    { value: 8, cname: "shop", center: [55.7458, 52.4543] },
    { value: 9, cname: "radar", center: [55.7458, 52.4568] },
    { value: 10, cname: "motel", center: [55.7458, 52.4593] },
    { value: 11, cname: "service", center: [55.7443, 52.4497] },
    { value: 12, cname: "cafe", center: [55.7443, 52.4518] },
    { value: 13, cname: "tirefitting", center: [55.7443, 52.4543] },
    { value: 14, cname: "water", center: [55.7443, 52.4568] },
    { value: 15, cname: "crahsinjury", center: [55.7443, 52.4593] },
];

const filters = [
    { label: "Платон", value: 1, cname: "platon" },
    { label: "Стац. камера", value: 2, cname: "camera" },
    { label: "АЗС", value: 3, cname: "azs" },
    { label: "Туалеты", value: 4, cname: "toilet" },
    { label: "Стирка", value: 5, cname: "wash" },
    { label: "Эвакуатор", value: 6, cname: "wrecker" },
    { label: "ДПС", value: 7, cname: "dps" },
    { label: "Магазин", value: 8, cname: "shop" },
    { label: "Радар", value: 9, cname: "radar" },
    { label: "Места сна", value: 10, cname: "motel" },
    { label: "СТО", value: 11, cname: "service" },
    { label: "Кафе", value: 12, cname: "cafe" },
    { label: "Шиномонтаж", value: 13, cname: "tirefitting" },
    { label: "Вода", value: 14, cname: "water" },
    { label: "Дтп", value: 15, cname: "crahsinjury" },
];

const defaultCircleRadius = 2000;

export const defaultBidDataFilters = {
    mobile: false,
    tracker: true,
    stops: true,
    refuelings: true,
    tollRoads: true,
    postamats: false,
    platonPoints: true,
    paymentPoints: true,
    emergencyAreaPoints: true,
    routeControlPoints: true,
    unstableZones: true,
    regionDryingFilters: isRegionDryingPeriodsEnabledForClients,
};

export const getDefaultBidDataFilters = () => {
    const filters = { ...defaultBidDataFilters, ...load("bidData", {}) };
    return isRegionDryingPeriodsEnabledForClients ? filters : { ...filters, regionDryingFilters: false };
};

export default class PointsFiltersMap extends Component {
    state = {
        filters,
        points,
        activeFilters: [],
        bidFilters: getDefaultBidDataFilters(),
        isFilterOpened: false,
        showRegionDryingFilters: isRegionDryingPeriodsEnabledForClients
            ? load("show-region-drying-periods", false)
            : false,
    };

    componentDidMount() {
        const { location, mergeMapData, roles } = this.props;
        this.recalcMapPosition();
        if (
            ROOT_PAGE_LINKS.includes(location.pathname) &&
            !noRolesOtherThan(roles, ["isTechSupport", "isAccountManager", "isDiagnostics"])
        ) {
            mergeMapData({ isLoading: true, renderCarMarkers: true });
        }
    }

    componentDidUpdate(prevProps) {
        const { location, fullscreen, shouldResize } = this.props;
        if (location.pathname !== prevProps.location.pathname) {
            this.recalcMap();
        } else if (fullscreen !== prevProps.fullscreen) {
            this.recalcMap(400);
        } else if (shouldResize !== prevProps.shouldResize) {
            this.recalcMap();
        }
        this.recalcMapPosition(prevProps);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const mapData = {};
        if (
            noRolesOtherThan(nextProps.roles, ["isTechSupport", "isAccountManager", "isDiagnostics"]) ||
            !nextProps.roles
        ) {
            return;
        }
        if (ROOT_PAGE_LINKS.includes(nextProps.location.pathname)) {
            if (!nextProps.data.renderCarMarkers) {
                mapData.renderCarMarkers = true;
            }

            if (nextProps.data.carsLoadedAt) {
                if (nextProps.data.isLoading) {
                    mapData.isLoading = false;
                }
            } else {
                if (!nextProps.data.isLoading) {
                    mapData.isLoading = true;
                }
            }
        } else {
            if (this.props.data.renderCarMarkers) {
                mapData.renderCarMarkers = false;
            }
        }
        if (Object.keys(mapData).length > 0) {
            setTimeout(() => this.props.mergeMapData(mapData), 0);
        }
    }

    recalcMapPosition = () => {
        return null;
    };

    recalcMap = (timeout = 200) => {
        setTimeout(() => {
            if (this.map) {
                this.map.invalidateSize();
            }
        }, timeout);
    };

    handleViewportChange = (nextState) => {
        this.props.mergeMapViewport(nextState);
        this.recalcMap();
    };

    changeMapPosition = (bounds, zoom = 10) => {
        const notNullPoints = [...compact(bounds)];
        setTimeout(() => {
            if (notNullPoints.length && this.map) {
                this.map.fitBounds(notNullPoints, { maxZoom: zoom, padding: [50, 50] });
            }
        }, 200);
    };

    renderFilter = () => {
        const { filters, activeFilters, showRegionDryingFilters } = this.state;
        const { hideZoomControl, location, enums, params, mergeParams, profile, data } = this.props;
        if (!ROOT_PAGE_LINKS.includes(location.pathname) || (data && data.currentBid)) {
            return null;
        }
        const props = {
            filters,
            activeFilters,
            enums,
            hideZoomControl,
            params,
            mergeParams,
            location,
            profile,
            showRegionDryingFilters,
            toggleShowRegionDryingFilters: () => {
                store("show-region-drying-periods", !showRegionDryingFilters);
                this.setState({ showRegionDryingFilters: !showRegionDryingFilters });
            },
        };
        return <Filter {...props} />;
    };

    renderBidDataFilter = () => null;

    roadRestrictionList = () => null;

    toggleFilter = (name) => {
        const { bidFilters } = this.state;
        const filters = { ...bidFilters, [name]: !(bidFilters[name] ?? true) };
        store("bidData", filters);
        this.setState({ bidFilters: filters });
    };

    toggleGroupFilter = (newItems) => {
        const { bidFilters } = this.state;
        const filters = { ...bidFilters, ...newItems };
        store("bidData", filters);
        this.setState({ bidFilters: filters });
    };

    renderAverageRateInfo = () => null;
    renderExternalBidInfo = () => null;
    renderBidDataLegend = () => null;

    renderTopLeftControl = () => {
        const { tileUrls } = this.props;

        const averageRateInfo = this.renderAverageRateInfo();
        const externalBidInfo = this.renderExternalBidInfo();

        if (!averageRateInfo && !externalBidInfo) {
            return null;
        }

        return (
            <MapControl position="topleft">
                <div
                    className="d-flex flex-column gap-1 align-items-start"
                    {...(tileUrls?.length > 1 ? { style: { position: "absolute", left: "65px" } } : {})}
                >
                    {averageRateInfo}
                    {externalBidInfo}
                </div>
            </MapControl>
        );
    };

    renderFixRouteBidForm = () => {
        const { currentBid, route, defaultRouteOptions } = this.props.data;
        if (!currentBid) {
            return null;
        }
        const { selectGeozoneMode, startGeozone, endGeozone, routeToFix } = this.state;
        if (!selectGeozoneMode && !startGeozone) {
            return null;
        }
        return (
            <FixRouteBidForm
                bidId={currentBid}
                routeOptions={route?.routeOptions}
                routerType={this.props.organization.routerType}
                defaultRouteOptions={defaultRouteOptions}
                startGeozone={startGeozone}
                endGeozone={endGeozone}
                routeToFix={routeToFix}
                selectGeozoneMode={selectGeozoneMode}
                cancelSelectRange={() =>
                    this.setState({
                        selectGeozoneMode: undefined,
                        startGeozone: undefined,
                        endGeozone: undefined,
                        routeToFix: undefined,
                    })
                }
            />
        );
    };

    renderFixRouteBidBtn = () => {
        const { currentBid } = this.props.data;
        if (!currentBid) {
            return null;
        }
        return (
            <FixRouteBidBtn
                startSelectRange={() =>
                    this.setState({
                        selectGeozoneMode: "start",
                        startGeozone: undefined,
                        endGeozone: undefined,
                        routeToFix: undefined,
                    })
                }
            />
        );
    };

    renderCheckRegistryPointsBtn = () => {
        const { currentBid } = this.props.data;
        if (!currentBid || !canManageOrganization(this.props.roles)) {
            return null;
        }
        return (
            <CheckRegistryPointsBtn
                checkRegistryPoints={() =>
                    this.setState({ checkRegistryPointsMode: !this.state.checkRegistryPointsMode })
                }
            />
        );
    };

    renderRequireForwardingOrderBtn = () => {
        const { currentBid, bid, refreshBid } = this.props.data;
        if (!currentBid) {
            return null;
        }
        return (
            <RequireForwardingOrderBtn
                forwardingOrder={bid?.forwardingOrder}
                bidId={Number(currentBid)}
                profile={this.props.profile}
                modal={this.props.modal}
                refreshBid={refreshBid}
            />
        );
    };

    setGeozonePoint = (point) => {
        if (!point) {
            return;
        }
        this.props.mergeMapData({ isLoading: true });
        geocoder({ lng: point[0], lat: point[1] }).then((geozone) => {
            if (this.state.selectGeozoneMode === "start") {
                this.props.mergeMapData({ isLoading: false });
                this.setState({ startGeozone: geozone, selectGeozoneMode: "end" });
            } else {
                const segmentCoords = [this.state.startGeozone.location.coordinates, geozone.location.coordinates];
                return getRoute(segmentCoords, {
                    routeOptions: getClientRouteOptions(this.props.data.route.routeOptions),
                }).then((data) => {
                    this.props.mergeMapData({ isLoading: false });
                    this.setState({
                        routeToFix: data?.concatedCoords || [],
                        endGeozone: geozone,
                        selectGeozoneMode: "form",
                    });
                });
            }
        });
    };

    renderBody = () => null;

    renderRouteMarkers = (markers = []) => {
        let index = -1;
        let firstLoadPointIndex = -1;
        markers?.some((item) => {
            if ([bidPointTypesEnum.ServicePoint, bidPointTypesEnum.StartPoint].includes(item.type)) {
                return false;
            }
            firstLoadPointIndex++;
            return [bidPointTypesEnum.LoadPoint, bidPointTypesEnum.UnloadPoint].includes(item.type);
        });
        const markersHtml = markers.map((item) => {
            if (
                ![bidPointTypesEnum.StartPoint, bidPointTypesEnum.ServicePoint].includes(item.type) &&
                (this.props.mod !== "create-route" || item.panelType === "bidpoint")
            ) {
                index++;
            }
            const props = {
                item,
                index,
                firstLoadPointIndex,
                markersWithoutTooltips: this.props.markersWithoutTooltips,
                data: this.props.data,
                mod: this.props.mod,
                updatePosition: (point, event) => this.updatePosition(point, firstLoadPointIndex, event),
            };
            return <RouteMarker key={item.id} {...props} />;
        });
        return (
            <>
                <MarkerCluster maxClusterRadius={20}>{markersHtml}</MarkerCluster>
                {this.renderMarkersCircle(markers)}
            </>
        );
    };

    renderMarkersCircle = (markers) => {
        const markersWithoutTooltips = this.props.markersWithoutTooltips || false;
        if (markersWithoutTooltips) {
            return null;
        }
        return markers.map((item, i) => {
            const { coordinates } = item.geozone.location;
            const inverted = [coordinates[1], coordinates[0]];
            if (item.geozone.coordinates) {
                return (
                    <Polygon
                        key={`markerCircle${i}`}
                        positions={item.geozone.coordinates.map((coords) => [...coords].reverse())}
                    />
                );
            } else {
                return (
                    <Circle
                        key={`markerCircle${i}`}
                        center={inverted}
                        radius={item.geozone.radius || defaultCircleRadius}
                    />
                );
            }
        });
    };

    updatePosition = (point, firstLoadPointIndex, { target, target: { options } }) => {
        const latlng = target.getLatLng();
        setTimeout(() => {
            this.props.mergeMapData({ isLoading: true });
            const nearestPoint = { distance: null, point: null };
            const {
                modal,
                data: { updatePoint, bidPoints },
            } = this.props;
            const pointIndex = bidPoints.indexOf(point);
            const pointIndexes =
                pointIndex === -1
                    ? []
                    : [pointIndex - 1, pointIndex + 1].filter((item) => item >= 0 && item < bidPoints.length);
            pointIndexes.forEach((index) => {
                const bidPoint = bidPoints[index];
                const distance = latlng.distanceTo([...bidPoint.geozone.location.coordinates].reverse());
                if (distance < 1000 && !(nearestPoint.distance || nearestPoint.distance > distance)) {
                    nearestPoint.distance = distance;
                    nearestPoint.point = bidPoint;
                }
            });
            const updateByCurrentLatLng = () => {
                geocoder(latlng).then((geopoint) => {
                    this.props.mergeMapData({ isLoading: false });
                    if (geopoint) {
                        return modal({
                            name: "updatePosition",
                            title:
                                options.pointType === bidPointTypesEnum.UnloadPoint
                                    ? "Изменение точки выгрузки"
                                    : "Изменение точки загрузки",
                            text: `Вы хотите изменить точку на "${geopoint.address}"?`,
                            buttons: { confirm: "Да", cancel: "Нет" },
                            data: geopoint,
                            optionId: options.id,
                            updatePoint,
                        });
                    }
                });
            };
            if (nearestPoint.distance) {
                const first = isStartBidPoint(point.geozone.type)
                    ? START_POINT_LETTER
                    : pointLetter(point.order, firstLoadPointIndex);
                const second = isStartBidPoint(nearestPoint.point.geozone.type)
                    ? START_POINT_LETTER
                    : pointLetter(nearestPoint.point.order, firstLoadPointIndex);
                return modal({
                    name: "confirm",
                    title:
                        options.pointType === bidPointTypesEnum.UnloadPoint
                            ? "Изменение точки выгрузки"
                            : "Изменение точки загрузки",
                    text: `Изменить в точке "${first}" адрес на тот, который указан в точке "${second}"?`,
                    buttons: { confirm: "Да", cancel: "Нет" },
                    onCancelAction: (success) => !success && updateByCurrentLatLng(),
                    mergeMapData: this.props.mergeMapData,
                    action: () => {
                        const { geozone } = nearestPoint.point;
                        const geopoint = {
                            city: geozone.city,
                            county: geozone.county,
                            federalDistrict: geozone.federalDistrict,
                            houseNumber: geozone.houseNumber,
                            state: geozone.state,
                            street: geozone.street,
                            village: geozone.village,
                            location: geozone.location,
                            address: geozone.address,
                        };
                        return updatePoint(geopoint, options.id);
                    },
                });
            } else {
                updateByCurrentLatLng();
            }
        }, 0);
    };

    recalculationData = (data) => {
        const { previousTrackedBid, nextTrackedBid } = data || {};
        return (
            <div className="p-2 map__control--body border-bottom border-secondary">
                <div>
                    Предыдущая заявка:{" "}
                    <a
                        className="map__control--link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={paths.bidShow("bid", previousTrackedBid?.bidId)}
                    >
                        {previousTrackedBid?.bidId}
                    </a>
                </div>
                <div>
                    Следующая заявка:{" "}
                    <a
                        className="map__control--link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={paths.bidShow("bid", nextTrackedBid?.bidId)}
                    >
                        {nextTrackedBid?.bidId}
                    </a>
                </div>
                <div>
                    Плановая дата посещения последней точки предыдущей заявки:{" "}
                    {dateTimeToView(previousTrackedBid?.lastPlanEnterDate)}
                </div>
                <div>
                    Дата въезда в последнюю точку предыдущей заявки:{" "}
                    {dateTimeToView(previousTrackedBid?.lastPointEnteredAt)}
                </div>
                <div>
                    Ближайший период машина - заявка предыдущей заявки:{" "}
                    {dateTimeToView(previousTrackedBid?.closestCarPeriodEndedAt)}
                </div>
                <div>
                    Плановая дата посещения первой точки следующей заявки:{" "}
                    {dateTimeToView(nextTrackedBid?.firstPlanEnterDate)}
                </div>
                <div>
                    Дата выезда из первой точки следующей заявки: {dateTimeToView(nextTrackedBid?.firstPointLeftAt)}
                </div>
                <div>
                    Ближайший период машина - заявка следующий заявки:{" "}
                    {dateTimeToView(nextTrackedBid?.closestCarPeriodStartedAt)}
                </div>
            </div>
        );
    };

    getCurrentRouteOptions = () => {
        const { route, defaultRouteOptions } = this.props.data;
        return getClientRouteOptions(route?.routeOptions || defaultRouteOptions);
    };

    showUpdateRouteModal = (routeOptions) => {
        const { currentBid, route, defaultRouteOptions, refreshBid, bidPoints } = this.props.data;
        this.props.modal({
            name: "default",
            title: "Обновление маршрута заявки",
            CustomBody: UpdateRoute,
            bodyData: {
                bidId: currentBid,
                routeOptions: getClientRouteOptions(routeOptions || route?.routeOptions || defaultRouteOptions),
                defaultRouteOptions: getClientRouteOptions(defaultRouteOptions),
                refreshBid,
                bidPoints,
                modal: this.props.addModal,
            },
        });
    };

    updateRouteWithoutSeasonalRestrictions = () => {
        const { currentBid, bidPoints } = this.props.data;
        const routeOptions = this.getCurrentRouteOptions();
        const nextRouteOptions = routeOptions ? routeOptionsWithoutSeasonalRestrictions(routeOptions) : routeOptions;

        if (!currentBid || !bidPoints || !nextRouteOptions) {
            return Promise.resolve({ routeUpdated: false, routeOptions: nextRouteOptions });
        }

        this.props.mergeMapData({ isLoading: true });

        return applyBidRoute({
            bidId: currentBid,
            bidPoints,
            settings: { routeOptions: nextRouteOptions },
        }).then(
            (res) => {
                this.props.mergeMapData({ isLoading: false });
                return { routeUpdated: !!res, routeOptions: nextRouteOptions };
            },
            (err) => {
                this.props.mergeMapData({ isLoading: false });
                throw err;
            },
        );
    };

    allowSeasonalRestrictedRoads = () => {
        this.props.modal({
            ...seasonalRestrictionsConfirmParams(this.updateRouteWithoutSeasonalRestrictions),
            onSuccessAction: ({ routeUpdated, routeOptions } = {}) => {
                if (routeUpdated) {
                    return this.props.data.refreshBid?.();
                }
                return this.showUpdateRouteModal(routeOptions);
            },
        });
    };

    render() {
        const { viewport, hideZoomControl, tileUrls, data, className, withoutViewportCheck } = this.props;
        if (!tileUrls) {
            return null;
        }
        return (
            <>
                {data && data.isLoading && (
                    <div className="loader-snippet--map-loader">
                        <Loader />
                    </div>
                )}
                <LeafletMap
                    ref={(map) => (this.map = map)}
                    mapRef={this.map}
                    viewport={viewport}
                    tileUrls={tileUrls}
                    onViewportChanged={this.handleViewportChange}
                    zoomControl={false}
                    maxZoom={18}
                    withoutViewportCheck={withoutViewportCheck}
                    className={className}
                >
                    {this.renderBody()}
                    {this.renderTopLeftControl()}
                    {this.renderFixRouteBidForm()}
                    <MapControl position="topright">
                        <div className="d-flex flex-column gap-1 align-items-end">
                            {this.renderBidDataFilter()}
                            {this.roadRestrictionList()}
                        </div>
                    </MapControl>
                    <MapControl position="bottomleft">
                        <div className="d-flex flex-column-reverse gap-1 align-items-start">
                            {this.renderBidDataLegend()}
                            {this.renderFixRouteBidBtn()}
                            {this.renderCheckRegistryPointsBtn()}
                            {this.renderRequireForwardingOrderBtn()}
                        </div>
                    </MapControl>
                    {data.currentBid && isTechSupport() && (
                        <div className="leaflet-bottom leaflet-right map__control">
                            <div className="leaflet-control leaflet-bar mb-0">
                                {data.expandedRangeTime && this.recalculationData(data.recalculationData)}
                                <div className="map__control--btn">
                                    <div className="btn btn-sm" onClick={data.toggleExpandedRangeTime}>
                                        <i
                                            className={cn("checkbox mr-2 d-inline-block", {
                                                "checkbox--checked": data.expandedRangeTime,
                                            })}
                                        />
                                        Расширить трекер-логи
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {data.currentBid && data.pointsNotComparedToSegments && (
                        <div className="map__route-error">
                            <div className="alert alert-danger map__route-error-alert mb-0">
                                <div className="map__route-error-text">
                                    {isRegionDryingPeriodsEnabledForClients
                                        ? "Не удалось построить маршрут из-за сезонных ограничений. До точки заявки можно доехать только по дороге с ограничением проезда. Разрешите проезд по таким дорогам, чтобы построить маршрут."
                                        : "Не удалось построить маршрут до точки заявки. Проверьте точки заявки и настройки маршрута."}
                                </div>
                                {isRegionDryingPeriodsEnabledForClients ? (
                                    <div className="btn btn-sm btn-brand" onClick={this.allowSeasonalRestrictedRoads}>
                                        Разрешить и построить маршрут
                                    </div>
                                ) : (
                                    <div className="btn btn-sm btn-brand" onClick={() => this.showUpdateRouteModal()}>
                                        Обновить маршрут
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {!!hideZoomControl === false && <ZoomControl position="bottomright" />}
                </LeafletMap>
                {this.renderFilter()}
            </>
        );
    }
}
